import {
    OPEN_CLOSE_BET_HISTORY,
    SELECT_BET_HISTORY_GAME,
    SELECT_BET_HISTORY_TAB,
    TOGGLE_BET_HISTORY_FILTER_WINS
} from '../constants/actionTypes';

export function openCloseBetBetHistory() {
    return {type: OPEN_CLOSE_BET_HISTORY};
}

export function selectBetHistoryTab(tabIndex) {
    return {type: SELECT_BET_HISTORY_TAB, tabIndex};
}

export function selectBetHistoryGame(gameChannel) {
    return {type: SELECT_BET_HISTORY_GAME, gameChannel};
}

export function toggleBetHistoryFilterWins() {
    return {type: TOGGLE_BET_HISTORY_FILTER_WINS};
}



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/actions/betHistoryActions.js